;(function ($) {

  var searchToggleButton = $('#z_search_toggle'),
    searchformHeader = $('#z_searchform_header'),
    searchField = $('#z_searchform_header_field'),
    slickSlider = $('#masthead_slider');

  $(document).ready(function () {

    $('body').on('click', '#z_search_toggle', searchToggle);

    // NOT YET USED
    //$( 'body').on( 'click', '#scroll_to_top', scrollToTop );
    //$( 'body' ).on( 'click', 'ul.page-list span.arrow', toggleSubPages );

    if ($('body').hasClass('home')) {
      initSlickSlider();
    }

  });

  /**
   * Toggles the search bar in the header and then focuses in the search bar once it appears.
   *
   * @param {object} e
   * @returns {void}
   */
  function searchToggle() {
    //console.log( 'searchToggle' );

    if (searchformHeader.hasClass('open')) {
      searchToggleButton.removeClass('open');
      searchformHeader.removeClass('open');
      searchformHeader.attr('aria-hidden', true);
    } else {
      searchformHeader.addClass('open');
      searchToggleButton.addClass('open');
      searchformHeader.attr('aria-hidden', false);
      searchField.focus();
    }


  }

  /**
   * Toggles the sub pages in the sidebar
   *
   * @param {object} e
   * @returns {void}
   */
  function toggleSubPages(e) {
    e.preventDefault();
    //console.log( 'submenu toggled' );
    var $this = $(this),
      children = $this.parent('a').siblings('.children');

    if ($this.hasClass('open')) {
      children.slideUp(300, function () {
        $this.removeClass('open');
        children.removeClass('open');
      });
    } else {
      children.slideDown(300, function () {
        $this.addClass('open');
        children.addClass('open');
      });
    }
  }

  /**
   * Animates the page back to the top.
   */
  function scrollToTop() {
    $('html,body').animate({
      scrollTop: 0
    }, 500);
  }


  $(window).load(function () {
    if (Foundation.MediaQuery.atLeast('medium')) {
      initFullResImages();
    }
  });

  /**
   * Looks for any image with data attribute: data-full-res and swaps out the low res version with full res.
   */
  function initFullResImages() {
    //console.log('initFullResImages');
    $('[data-full-res]').each(function (index, item) {
      var $this = $(item),
        fullResURL = $this.attr('data-full-res');


      var image = document.images[index];
      var downloadingImage = new Image();
      downloadingImage.onload = function () {
        $this.css('background-image', 'url(' + fullResURL + ')');
      };
      downloadingImage.src = fullResURL;

    });
  }


  /**
   * Init the Slider(s) if any are on page.
   */
  function initSlickSlider() {
    if (slickSlider) {
      console.log('initSlickSlider');
      $('#masthead_slider').slick({
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: true,
        speed: 1200,
        fade: true,
        cssEase: 'linear'
      });
    }
  }


  $(window).on('changed.zf.mediaquery', function (event, name) {
    console.log('Breakpoint Watch: ', name);
  });

})(jQuery);
/**
 * Created by Zeitguys on 2016-07-06.
 */
